import { Component, Input, CUSTOM_ELEMENTS_SCHEMA, ElementRef, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { faCamera } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ApiServicesService } from '../services/api-services.service';
import { HttpClientModule } from '@angular/common/http';
import { UserDetailsService } from '../services/user-details.service';
import { AfterViewInit, VERSION, ViewChild } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { AngularPinturaModule } from '@pqina/angular-pintura';
import { SnackbarService } from '../services/snackbar.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { response } from 'express';
import { getEditorDefaults } from '@pqina/pintura';
import { HeaderComponent } from '../header/header.component';
import { MatDialog } from '@angular/material/dialog';
import { ImageModalComponent } from '../image-modal/image-modal.component';
import { environment } from '../../envoirnments/environment';

@Component({
  selector: 'app-profilebanner',
  standalone: true,
  imports: [CommonModule, FontAwesomeModule, HttpClientModule, AngularPinturaModule, MatProgressSpinnerModule, HeaderComponent],
  templateUrl: './profilebanner.component.html',
  styleUrls: ['./profilebanner.component.css'],
})

export class ProfilebannerComponent {

  @ViewChild('fileInput1') fileInput!: ElementRef<HTMLInputElement>;
  src: any = '';
  showPinturaEditor: boolean = false;
  options: any = {
    ...getEditorDefaults(),
    enableButtonClose: true,
  };
  hovering = false;
  userData: any = {};
  name: string = '';
  location: string = '';
  Contry: string = '';
  age: string = '';
  profileCoverImage!: string;
  faCamera = faCamera;
  is_free_member: boolean = true;
  baseUrl: string = environment.baseUrl;
  profileimg: string = '';
  loader = true;
  friendStatus: any = 0;
  profile_loader=false;
  @Input() is_my_profile: boolean = true;
  editedImage: any;
  editorConfig = {
    includeUI: {
      loadImage: {
        path: 'assets/sample-image.jpg',
        name: 'Sample Image',
      },
      theme: {
        'menu.background': '#f0f0f0',
      },
      initMenu: 'filter',
      uiSize: {
        width: '100%',
        height: '700px',
      },
    },
  };
  is_block: boolean = false;

  constructor(
    private userdetails: UserDetailsService,
    public apiService: ApiServicesService,
    private snackbarService: SnackbarService,
    private router: Router,
    private dialog: MatDialog,
  ) { }

  userName: any = '';
  showText: boolean = true;

  ngOnInit() {
    this.loader = true;
    this.userData = {};
    this.userdetails.userdetails$.subscribe((userData) => {
      this.loader = true;
      this.userData = userData;
      if(userData!==null){
      if (userData && userData.user) {
        this.friendStatus = userData.friendStatus;
        this.name = userData.user.username;
        this.age = userData.user.age || 0;
        this.location = userData.user.state?.name;
        this.Contry = userData.user.country?.name;
        this.profileimg = userData.thumbnail_image;
        if (userData.cover_image) {
          this.imagePreview = userData.cover_image;
        }
        this.loader = false;
      }
    }else{
      this.loader = true;
    }
    });
  }

  ngOnDestroy() {
    this.loader = true;
    this.userData = {};
  }

  viewOthersProfile() {
    this.apiService.viewOthersProfile(this.name).subscribe({
      next: (response) => {
        if (this.friendStatus == 2 || this.friendStatus == 3) {
          this.userdetails.Gotuserdetails(response);
        }
        this.userData = response;
        this.friendStatus = response.friendStatus;
        this.name = response.user.username || '-';
        this.age = response.user.age || 0;
        this.location = response.user.state?.name || '-';
        this.Contry = response.user.country?.name || '-';
        this.profileimg = response.thumbnail_image || '';
        this.imagePreview = response.cover_image;
      },
      error: (err) => {
        this.snackbarService.openCustomSnackbar(
          {
            icon: false,
            message: err.error.message,
            className: 'failed',
          }
        );
      },
    });
  }

  showLoader: boolean = false;

  sendFriendRequest() {
    this.showLoader = true;

    if (this.userData.friendStatus == 0) {
      var data = {
        friend_id: this.userData.user._id,
      }
      this.apiService.sendFriendRequest(data).subscribe({
        next: (response) => {
          this.showLoader = false;
          this.viewOthersProfile();
          this.snackbarService.openCustomSnackbar(
            {
              icon: true,
              message: response.message,
              className: 'success',
            }
          );
        },
        error: (err) => {
          this.showLoader = false;
          this.snackbarService.openCustomSnackbar(
            {
              icon: false,
              message: err.error.message,
              className: 'failed',
            }
          );
        },
      })
    } else if (this.userData.friendStatus == 3) {
      this.apiService.acceptFriendrequest(this.userData.user._id).subscribe({
        next: (response) => {
          this.showLoader = false;
          this.viewOthersProfile();
          this.snackbarService.openCustomSnackbar(
            {
              icon: true,
              message: response.message,
              className: 'success',
            }
          );
        },
        error: (err) => {
          this.showLoader = false;
          this.snackbarService.openCustomSnackbar(
            {
              icon: false,
              message: err.error.message,
              className: 'failed',
            }
          );
        },
      });
    } else {
      var data2 = {
        targetUserId: this.userData.user._id,
      }
      this.apiService.cancelFriendRequest(data2).subscribe({
        next: (response) => {
          this.showLoader = false;
          this.viewOthersProfile();
          this.snackbarService.openCustomSnackbar(
            {
              icon: true,
              message: response.message,
              className: 'success',
            }
          );
        },
        error: (err) => {
          this.showLoader = false;
          this.snackbarService.openCustomSnackbar(
            {
              icon: false,
              message: err.error.message,
              className: 'failed',
            }
          );
        },
      })
    }
  }

  imagePreview: string = '';
  activeFileType: any = '';
  banner_loader=false;


  onFileSelected_banner(event: Event): void {
    this.banner_loader=true;
    const input = event.target as HTMLInputElement;

    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      const formData = new FormData();
      formData.append('coverpic', file, 'edited-image.png');
      this.apiService.updateCoverProfile(formData).subscribe({
        next: (response) => {
          this.imagePreview = response.cover_image;
          const encryptedData = localStorage.getItem('encryptedUserData');
          if (encryptedData) {
            const decryptedData = this.apiService.decryptData(encryptedData);
            decryptedData.cover_image = response.cover_image;
            this.userdetails.Gotuserdetails(decryptedData);
            const encryptedDataTemp = this.apiService.encryptData(decryptedData);
            localStorage.setItem('encryptedUserData', encryptedDataTemp);
          }
          this.showPinturaEditor = false;
          this.banner_loader=false;
          this.snackbarService.openCustomSnackbar(
            {
              icon: true,
              message: response.message,
              className: 'success',
            }
          );
        },
        error: (err) => {
          console.error('Error updating profile:', err);
        },
      });
    } else {
      this.imagePreview = '';
    }
  }

  onFileSelected_profile(event: Event): void {
    this.profile_loader=true;
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      const formData = new FormData();
      formData.append('image', file, 'edited-image.png');
      this.apiService.updateProfilePicture(formData).subscribe({
        next: (response) => {
          this.profileimg = response.profile_pic;
          const encryptedData = localStorage.getItem('encryptedUserData');
          if (encryptedData) {
            const decryptedData = this.apiService.decryptData(encryptedData);
            decryptedData.profile_pic = response.profile_pic;
            this.userdetails.Gotuserdetails(decryptedData);
            const encryptedDataTemp = this.apiService.encryptData(decryptedData);
            localStorage.setItem('encryptedUserData', encryptedDataTemp);
          }
          this.showPinturaEditor = false;
          this.profile_loader=false;
          this.snackbarService.openCustomSnackbar(
            {
              icon: true,
              message: response.message,
              className: 'success',
            }
          );
        },
        error: (err) => {
          console.error('Error updating profile:', err);
        },
      });
    } else {
      this.profile_loader=false;
    }
  }

  onFileSelected(event: any, fileType: string): void {
    const file = event.target.files[0];
    if (file) {
      this.activeFileType = fileType;
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.src = e.target.result;
        this.showPinturaEditor = true;
      };
      reader.readAsDataURL(file);
    }
  }

  onEditorClose(): void {
    this.showPinturaEditor = false;
  }


  openImageModal(imageUrl: string): void {
        this.dialog.open(ImageModalComponent, {
          data: { imageUrl },
        });
      }


  handleProcess(event: any) {
    const processedImage = event.dest;
    const formData = new FormData();
    if (this.activeFileType === 'banner') {
      formData.append('coverpic', processedImage, 'edited-image.png');
      this.apiService.updateCoverProfile(formData).subscribe({
        next: (response) => {
          this.imagePreview = response.cover_image;
          const encryptedData = localStorage.getItem('encryptedUserData');
          if (encryptedData) {
            const decryptedData = this.apiService.decryptData(encryptedData);
            decryptedData.cover_image = response.cover_image;
            this.userdetails.Gotuserdetails(decryptedData);
            const encryptedDataTemp = this.apiService.encryptData(decryptedData);
            localStorage.setItem('encryptedUserData', encryptedDataTemp);
          }
          this.showPinturaEditor = false;
          this.snackbarService.openCustomSnackbar(
            {
              icon: true,
              message: response.message,
              className: 'success',
            }
          );
        },
        error: (err) => {
          console.error('Error updating profile:', err);
        },
      });
    } else {
      formData.append('image', processedImage, 'edited-image.png');
      this.apiService.updateProfilePicture(formData).subscribe({
        next: (response) => {
          this.profileimg = response.profile_pic;
          const encryptedData = localStorage.getItem('encryptedUserData');
          if (encryptedData) {
            const decryptedData = this.apiService.decryptData(encryptedData);
            decryptedData.profile_pic = response.profile_pic;
            this.userdetails.Gotuserdetails(decryptedData);
            const encryptedDataTemp = this.apiService.encryptData(decryptedData);
            localStorage.setItem('encryptedUserData', encryptedDataTemp);
          }
          this.showPinturaEditor = false;
          this.snackbarService.openCustomSnackbar(
            {
              icon: true,
              message: response.message,
              className: 'success',
            }
          );
        },
        error: (err) => {
          console.error('Error updating profile:', err);
        },
      });
    }


  }


  onEditorDone(event: any): void {
    const editedImage = event.detail;

    if (editedImage) {
    } else {
      console.error('No edited image found.');
    }

    this.showPinturaEditor = false;
  }


  confirmBlock() {
    var data = {
      userIdToBlock: this.userData.user._id,
    }
    this.showText = false;
    this.apiService.blockUser(data).subscribe({
      next: (value) => {
        this.is_block = false;
        this.snackbarService.openCustomSnackbar(
          {
            icon: true,
            message: value.message,
            className: 'success',
          }
        );
        const userdata = localStorage.getItem('encryptedUserData');
        if (userdata) {
          const decryptedData = this.apiService.decryptData(userdata);

          if (decryptedData && decryptedData.user) {
            this.router.navigate(['/my-profile', decryptedData.user.username, 'settings'], {
              queryParams: { tab: 'block' }
            });
          }
        }
      }, error: (err) => {
        this.snackbarService.openCustomSnackbar(
          {
            icon: false,
            message: err.message,
            className: 'failed',
          }
        );
      },
    },)
  }

  triggerFileUpload_banner(fileInput1: HTMLInputElement): void {
    fileInput1?.click();
  }

  triggerFileUpload_profile(fileInput1: HTMLInputElement): void {
    fileInput1?.click();
  }
}
